export default {
  title: 'Integracja kalendarza',
  notConfigured:
    'Integracja z kalendarzem Microsoft nie jest skonfigurowana dla tej organizacji.',
  queryError: 'Błąd podczas ładowania danych integracji kalendarza.',
  loadingStatus: 'Ładowanie statusu integracji Microsoft',
  loadingMappings: 'Ładowanie danych integracji kalendarza',
  status: {
    title: 'Status integracji Microsoft',
    PENDING: 'Oczekuje',
    ACTIVE: 'Aktywna',
    FAILED: 'Błąd',
    DISABLED: 'Wyłączona',
  },
  add: {
    title: 'Dodaj mapowanie sali',
    spaceLabel: 'Przestrzeń Lockspace',
    roomLabel: 'Sala Exchange',
    button: 'Dodaj mapowanie',
  },
  mappings: {
    title: 'Mapowania sal',
    empty: 'Nie dodano jeszcze żadnych mapowań sal.',
    removeLabel: 'Usuń mapowanie',
    columns: {
      space: 'Przestrzeń Lockspace',
      room: 'Sala Exchange',
      status: 'Status',
      actions: 'Akcje',
    },
  },
  removeDialog: {
    title: 'Usunąć mapowanie sali?',
    description:
      'Synchronizacja kalendarza zostanie wyłączona dla {{spaceName}}.',
    confirm: 'Usuń mapowanie',
  },
  toast: {
    addSuccess: 'Mapowanie sali zostało dodane pomyślnie.',
    removeSuccess: 'Mapowanie sali zostało usunięte pomyślnie.',
    spaceHasBookings:
      'Ta przestrzeń ma przyszłe rezerwacje Lockspace i nie może zostać jeszcze zmapowana.',
    roomNotEmpty:
      'Ta sala Exchange ma przyszłe zdarzenia w kalendarzu i nie może zostać jeszcze zmapowana.',
    roomUnavailable:
      'Wybrana sala Exchange jest niedostępna lub nieprawidłowa.',
  },
};
